'use strict';

module Dashboard {

    class DashboardBookingItinerary {
        template: string;
        bookingTitle: string;
        itineraries: any;
        bookingType: number;
        bookingTypes: any;
        insuranceProvider: string;
        itineraryType: {[key:string]:number};

        templateMap:{[key:number]:string} = {
            1: 'flight',
            2: 'tickets',
            4: 'car-hire',
            8: 'accommodation',
            9: 'holiday',
            16: 'parking',
            32: 'transfer',
            64: 'insurance',
            128: 'package-holidays',
            256: 'marhaba',
            1024: 'bundle',
            2048: 'adhoc'
        };

        constructor(
            private imageService,
            private dashboardBookingService,
            private resourceService: Core.ResourceService
        ) {
            this.template = this.templateMap[this.bookingType];
            this.bookingTypes = dashboardBookingService.getBookingTypeMap();
            this.itineraryType = dashboardBookingService.getItineraryType();

            if (this.bookingType === this.bookingTypes.travelInsurance) {
                this.insuranceProvider = this.bookingTitle.split(':')[0];
            }
        }

        getResourceValue(resource:string):string {
            return this.resourceService.get(resource);
        }

        filterTransfer(itinerary:any):boolean {
            return itinerary.Type === this.itineraryType['TransferArrival'] ||
                itinerary.Type === this.itineraryType['TransferReturn'];
        }

        getImage(estabId:number):string {
            return this.imageService.getImageUrl(estabId, 180, 180, 1);
        }

        getAcommImage(estabId:number):string {
            return this.imageService.getMainImageUrl(estabId, 370, 370);
        }

        getContentUrl() {
            return 'partials/dashboard/ItineraryTemplate?Type=' + this.template;
        }
    }

    angular
        .module('dashboard')
        .component('dashboardBookingItinerary', {
            bindings: {
                bookingTitle: '=',
                itineraries: '=',
                bookingType: '='
            },
            controller: DashboardBookingItinerary,
            controllerAs: 'bi',
            template: '<div ng-include="bi.getContentUrl()"></div>'
        });
}
